import { render, staticRenderFns } from "./live2.vue?vue&type=template&id=45b81677&scoped=true"
import script from "./live2.vue?vue&type=script&lang=js"
export * from "./live2.vue?vue&type=script&lang=js"
import style0 from "./live2.vue?vue&type=style&index=0&id=45b81677&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b81677",
  null
  
)

export default component.exports